import axiosCustom from "../utils/axiosInstance";
import { ChatConversationDto } from "../models/chat/ChatConversationDto";
import { ChatMessageDto, ChatMessageType } from "../models/chat/ChatMessageDto";

const API_BASE_URL = "/chat";

export const chatService = {
  getChatConversations: async (): Promise<ChatConversationDto[]> => {
    const res = await axiosCustom.get<ChatConversationDto[]>(`${API_BASE_URL}/conversations`);
    return res.data;
  },
  getChatMessages: async (partnerUserId: string, before?: string, size = 30): Promise<ChatMessageDto[]> => {
    const res = await axiosCustom.get<ChatMessageDto[]>(`${API_BASE_URL}/messages/${partnerUserId}`, {
      params: { before, size },
    });
    return res.data;
  },
  sendChatMessage: async (recipientUserId: string, content: string, messageType: ChatMessageType = "TEXT"): Promise<ChatMessageDto> => {
    const res = await axiosCustom.post<ChatMessageDto>(`${API_BASE_URL}/messages`, {
      recipientUserId,
      content,
      messageType,
    });
    return res.data;
  },
  sendChatAttachment: async (recipientUserId: string, files: File[], content?: string): Promise<ChatMessageDto> => {
    const form = new FormData();
    form.append("recipientUserId", recipientUserId);
    if (content) form.append("content", content);
    files.forEach((f) => form.append("files", f));
    const res = await axiosCustom.post<ChatMessageDto>(`${API_BASE_URL}/messages/attachment`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },
  downloadChatFile: async (fileId: string, fileName: string): Promise<void> => {
    const res = await axiosCustom.get(`${API_BASE_URL}/files/${fileId}/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(res.data as Blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
  markChatConversationRead: async (partnerUserId: string): Promise<void> => {
    await axiosCustom.patch(`${API_BASE_URL}/conversations/${partnerUserId}/read`);
  },
  getChatUnreadCount: async (): Promise<number> => {
    const res = await axiosCustom.get<{ count: number }>(`${API_BASE_URL}/unread-count`);
    return res.data.count;
  },
  getOnlinePresence: async (): Promise<string[]> => {
    const res = await axiosCustom.get<string[]>(`${API_BASE_URL}/presence`);
    return res.data;
  },
};
